export const OPEN_BOARDS_DIALOG_CLOSE = 'dialog:closed';
